<template>
    <div class="text-center mt-5">
        <h2>404 Page not found</h2>
        <button class="btn btn-secondary mt-3" @click="goBack">Back</button>
    </div>
</template>
<script>
export default {
    methods: {
        goBack() {
            this.$router.push('/home');
        }
    }
}
</script>
<style scoped>
</style>